var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorClipboardTask200)",
    d: "M4 4.506a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorClipboardTask203)",
    fillOpacity: 0.7,
    d: "M4 4.506a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorClipboardTask204)",
    fillOpacity: 0.4,
    d: "M4 4.506a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorClipboardTask201)",
    d: "M7 3.5A1.5 1.5 0 0 0 8.5 5h3a1.5 1.5 0 0 0 0-3h-3A1.5 1.5 0 0 0 7 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorClipboardTask202)",
    fillOpacity: 0.9,
    d: "M12.854 9.854a.5.5 0 0 0-.708-.708L9 12.293l-1.146-1.147a.5.5 0 0 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorClipboardTask200",
    x1: 4,
    x2: 16,
    y1: 4.506,
    y2: 18.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ab55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b258"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorClipboardTask201",
    x1: 10,
    x2: 10,
    y1: 2,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bee7c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bee7c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorClipboardTask202",
    x1: 15,
    x2: 7.55,
    y1: 16.5,
    y2: 5.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fluentColorClipboardTask203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 5.14077 -4.64062 0 10 2.173)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0a522b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#0a522b",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fluentColorClipboardTask204",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 2.30574 -3.67969 0 10 3.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0a522b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a522b",
    stopOpacity: 0
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/Task.ca37a9a5847fd165a4d860210917eeb4.svg";
export { ForwardRef as ReactComponent };